var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinCommercial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2905,
    cy: 14,
    r: 13.5,
    fill: "#25A764",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8281 8.54087H17.4437V7.1871C17.4437 6.82806 17.3011 6.48373 17.0472 6.22985C16.7933 5.97597 16.449 5.83334 16.09 5.83334H12.0287C11.6697 5.83334 11.3253 5.97597 11.0714 6.22985C10.8176 6.48373 10.6749 6.82806 10.6749 7.1871V8.54087H7.29053V9.89463H8.64429V20.0478C8.64429 20.5864 8.85823 21.1029 9.23905 21.4837C9.61987 21.8645 10.1364 22.0785 10.6749 22.0785H17.4437C17.9823 22.0785 18.4988 21.8645 18.8796 21.4837C19.2604 21.1029 19.4744 20.5864 19.4744 20.0478V9.89463H20.8281V8.54087ZM12.0287 7.1871H16.09V8.54087H12.0287V7.1871ZM18.1206 20.0478C18.1206 20.2274 18.0493 20.3995 17.9224 20.5265C17.7954 20.6534 17.6233 20.7247 17.4437 20.7247H10.6749C10.4954 20.7247 10.3232 20.6534 10.1963 20.5265C10.0694 20.3995 9.99805 20.2274 9.99805 20.0478V9.89463H18.1206V20.0478Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3821 17.3399V13.2786C13.3821 12.9048 13.079 12.6017 12.7052 12.6017C12.3314 12.6017 12.0283 12.9048 12.0283 13.2786V17.3399C12.0283 17.7137 12.3314 18.0168 12.7052 18.0168C13.079 18.0168 13.3821 17.7137 13.3821 17.3399Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0896 17.3399V13.2786C16.0896 12.9048 15.7866 12.6017 15.4127 12.6017C15.0389 12.6017 14.7358 12.9048 14.7358 13.2786V17.3399C14.7358 17.7137 15.0389 18.0168 15.4127 18.0168C15.7866 18.0168 16.0896 17.7137 16.0896 17.3399Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinCommercial);
export default __webpack_public_path__ + "static/media/trash-bin-commercial.39fb83d877e5fcf542557f551318ad1d.svg";
export { ForwardRef as ReactComponent };